import { Permissions } from './utils/enums/permissions.enum';
import { isSiteCanadian, isSystemAdminUIEnabled } from './utils/helpers';
import {
    LABEL_TEXT_MENU_CREDIT,
    LABEL_TEXT_MENU_CREDIT_APP,
    LABEL_TEXT_MENU_CREDIT_STATUS,
    LABEL_TEXT_MENU_EFT_NOTIFICATIONS,
    LABEL_TEXT_MENU_FUNDING,
    LABEL_TEXT_MENU_FUNDING_STATUS,
    LABEL_TEXT_MENU_HOME,
    LABEL_TEXT_MENU_MANAGE_USER,
    LABEL_TEXT_MENU_MY_CUSTOMERS,
    LABEL_TEXT_MENU_PAYMENTS,
    LABEL_TEXT_MENU_PAYMENTS_HISTORY,
    LABEL_TEXT_MENU_PAYMENTS_MAKE,
    LABEL_TEXT_MENU_PAYMENTS_PENDING,
    LABEL_TEXT_MENU_PAYOFF_QUOTES,
    LABEL_TEXT_MENU_PORTFOLIO,
    LABEL_TEXT_MENU_PROGRAM_ELIGIBILITY,
    LABEL_TEXT_MENU_RESERVES,
    LABEL_TEXT_MENU_RESOURCES,
    LABEL_TEXT_MENU_RESOURCES_BULLETINS,
    LABEL_TEXT_MENU_RESOURCES_DOCUMENTS,
    LABEL_TEXT_MENU_SERVICE_LOANER,
    LABEL_TEXT_MENU_SYSTEM_ADMIN,
} from './localization/resouceKeys';

export interface IRoutes {
    name: string;
    icon?: string;
    path: string;
    permissions?: Array<string>;
    childs?: Array<{ name: string; path: string; permissions?: Array<string> }>;
    fieldUserPermissions?: Array<string>;
}
export const getRoutes = () => {
    const Routes: Array<IRoutes> = [
        { name: LABEL_TEXT_MENU_HOME, icon: 'house', path: '/dashboard' },
        {
            name: LABEL_TEXT_MENU_CREDIT,
            icon: 'semantic-car-handover',
            path: '/dashboard/credit',
            childs: [
                {
                    name: LABEL_TEXT_MENU_CREDIT_APP,
                    path: '/dashboard/credit/application',
                    permissions: [Permissions.CREDIT_APPLICATION],
                },
                {
                    name: LABEL_TEXT_MENU_CREDIT_STATUS,
                    path: '/dashboard/credit/status',
                    permissions: [Permissions.APPLICATION_STATUS_TRACKING],
                },
            ],
        },
        {
            name: LABEL_TEXT_MENU_FUNDING,
            icon: 'piggybank',
            path: 'FundingComponent',
            childs: [
                {
                    name: LABEL_TEXT_MENU_FUNDING_STATUS,
                    path: 'funding/status',
                    permissions: [Permissions.FUNDING_STATUS],
                },
                {
                    name: LABEL_TEXT_MENU_EFT_NOTIFICATIONS,
                    path: 'funding/eft',
                    permissions: [
                        Permissions.DEALER_RESERVES_EFT_NOTIFICATIONS,
                    ],
                },
                {
                    name: LABEL_TEXT_MENU_RESERVES,
                    path: 'funding/reserves',
                    permissions: [
                        Permissions.DEALER_RESERVES_EFT_NOTIFICATIONS,
                    ],
                },
            ],
        },
        ...(!isSiteCanadian()
            ? [
                  {
                      name: 'Payoff/Turn in',
                      icon: 'semantic-calculator',
                      path: '/dashboard',
                      childs: [
                          {
                              name: 'Payoff Quotes',
                              path: '/dashboard/payoff-quotes',
                              permissions: [Permissions.PAYOFF_QUOTES],
                          },
                          {
                              name: 'Title Request',
                              path: '/dashboard/title-request',
                              permissions: [Permissions.PAYOFF_QUOTES],
                          },
                      ],
                  },
              ]
            : [
                  {
                      name: LABEL_TEXT_MENU_PAYOFF_QUOTES,
                      icon: 'semantic-calculator',
                      path: '/dashboard/payoff-quotes',
                      permissions: [Permissions.PAYOFF_QUOTES],
                  },
              ]),
        ...(!isSiteCanadian()
            ? [
                  {
                      name: LABEL_TEXT_MENU_MY_CUSTOMERS,
                      icon: 'magazine',
                      path: '/dashboard/my-customers',
                      childs: [
                          {
                              name: LABEL_TEXT_MENU_PROGRAM_ELIGIBILITY,
                              path: '/dashboard/program-eligibility',
                          },
                          {
                              name: LABEL_TEXT_MENU_PORTFOLIO,
                              path: '/dashboard/portfolio-management',
                              permissions: [
                                  Permissions.ASSIGN_MANAGE_SALES_MATURITIES,
                                  Permissions.VIEW_MATURITIES,
                                  Permissions.MATURITY_MANAGER,
                              ],
                          },
                      ],
                  },
              ]
            : [
                  {
                      name: LABEL_TEXT_MENU_PORTFOLIO,
                      icon: 'magazine',
                      path: '/dashboard/portfolio-management',
                      permissions: [
                          Permissions.ASSIGN_MANAGE_SALES_MATURITIES,
                          Permissions.VIEW_MATURITIES,
                          Permissions.MATURITY_MANAGER,
                      ],
                  },
              ]),
        {
            name: LABEL_TEXT_MENU_RESOURCES,
            icon: 'documents',
            path: 'FundingComponent',
            childs: [
                {
                    name: LABEL_TEXT_MENU_RESOURCES_DOCUMENTS,
                    path: 'resources/documents',
                },
                {
                    name: LABEL_TEXT_MENU_RESOURCES_BULLETINS,
                    path: 'resources/bulletins',
                    permissions: [Permissions.MARKETING_BULLETINS],
                },
            ],
        },
        {
            name: LABEL_TEXT_MENU_PAYMENTS,
            icon: 'semantic-fs-payment',
            path: 'HomeComponent',
            childs: [
                {
                    name: LABEL_TEXT_MENU_PAYMENTS_MAKE,
                    path: 'payments/make',
                    permissions: [
                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT,
                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT_AND_APPROVE,
                    ],
                },
                {
                    name: LABEL_TEXT_MENU_PAYMENTS_PENDING,
                    path: 'payments/pending',
                    permissions: [
                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT,
                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT_AND_APPROVE,
                    ],
                },
                {
                    name: LABEL_TEXT_MENU_PAYMENTS_HISTORY,
                    path: 'payments/history',
                    permissions: [
                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT,
                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT_AND_APPROVE,
                    ],
                },
            ],
        },
        ...(!isSiteCanadian()
            ? [
                  {
                      name: LABEL_TEXT_MENU_SERVICE_LOANER,
                      icon: 'car-square-checkmark',
                      path: '/dashboard/serviceLoaner',
                      permissions: [Permissions.SERVICE_LOANER],
                  },
                  /** {
                      name: LABEL_TEXT_MENU_DEALER_RENTAL,
                      icon: 'car-square-person',
                      path: '/dashboard/dealerRental',
                      permissions: [Permissions.DEALER_RENTAL],
                  },
                   */
              ]
            : []),
        {
            name: LABEL_TEXT_MENU_MANAGE_USER,
            icon: 'semantic-user',
            path: '/dashboard/dealer-management',
            permissions: [Permissions.USER_ADMIN],
        },
        ...(isSystemAdminUIEnabled()
            ? [
                  {
                      name: LABEL_TEXT_MENU_SYSTEM_ADMIN,
                      icon: 'semantic-settings',
                      path: '/dashboard/systemadmin',
                      permissions: [
                          Permissions.INTERNAL_SECURITY_MAINTENANCE,
                          Permissions.FIELD_ACCESS_MAINTENANCE,
                          Permissions.CONTENT_MAINTENANCE_PERMISSION,
                          Permissions.NEWS_STORY_MANAGEMENT,
                          Permissions.ONLINE_BULLETINS_MAINTENANCE,
                          Permissions.DISTRIBUTION_RULE_MANAGEMENT,
                          Permissions.DEALER_ACTIVATION,
                          Permissions.DEALER_SECURITY_MAINTENANCE,
                          Permissions.VEHICLE_MAINTENANCE,
                      ],
                  },
              ]
            : []),
    ];

    return Routes;
};

const Routes: Array<IRoutes> = getRoutes();

/**
 * System admin sub-pages that are not in the menu but still need a permission.
 * They are opened from other pages, so they are matched by their full path.
 */
export const SYSTEM_ADMIN_ROUTE_PERMISSIONS: Record<string, Array<string>> = {
    '/dashboard/systemadmin/upload-bulletin': [
        Permissions.ONLINE_BULLETINS_MAINTENANCE,
    ],
    '/dashboard/systemadmin/view-bulletin': [
        Permissions.ONLINE_BULLETINS_MAINTENANCE,
    ],
    '/dashboard/systemadmin/update-bulletin': [
        Permissions.ONLINE_BULLETINS_MAINTENANCE,
    ],
    '/dashboard/systemadmin/create-critical-organization-updates': [
        Permissions.NEWS_STORY_MANAGEMENT,
    ],
    '/dashboard/systemadmin/view-critical-organization-updates': [
        Permissions.NEWS_STORY_MANAGEMENT,
    ],
    '/dashboard/systemadmin/upload-vehicle-info': [
        Permissions.VEHICLE_MAINTENANCE,
    ],
    '/dashboard/systemadmin/search-vehicle-info': [
        Permissions.VEHICLE_MAINTENANCE,
    ],
    '/dashboard/systemadmin/create-distribution-rule': [
        Permissions.DISTRIBUTION_RULE_MANAGEMENT,
    ],
    '/dashboard/systemadmin/edit-distribution-rule': [
        Permissions.DISTRIBUTION_RULE_MANAGEMENT,
    ],
    // Also the rule picker used by Upload / Update Bulletin and Critical Organization Updates.
    '/dashboard/systemadmin/view-distribution-rule': [
        Permissions.DISTRIBUTION_RULE_MANAGEMENT,
        Permissions.ONLINE_BULLETINS_MAINTENANCE,
        Permissions.NEWS_STORY_MANAGEMENT,
    ],
};

// React Router ignores case and trailing slashes, so the lookup must too.
const normalizePath = (path: string) => path.replace(/\/+$/, '').toLowerCase();

export function isRestrictedSystemAdminRoute(pathname: string): boolean {
    const target = normalizePath(pathname);

    return Object.keys(SYSTEM_ADMIN_ROUTE_PERMISSIONS).some(
        (path) => normalizePath(path) === target,
    );
}

// Menu children may be relative to /dashboard (e.g. 'resources/bulletins').
const toDashboardPath = (path: string) =>
    path.startsWith('/') ? path : `/dashboard/${path}`;

export function getRoutesPermission(): Map<string, Array<string>> {
    const routesPermissionsMap = new Map<string, Array<string>>();
    for (const route of Routes) {
        if (route.permissions) {
            routesPermissionsMap.set(route.path, route.permissions);
        } else if (route.childs) {
            for (const chlid of route.childs) {
                if (chlid.permissions) {
                    routesPermissionsMap.set(
                        toDashboardPath(chlid.path),
                        chlid.permissions,
                    );
                }
            }
        }
    }

    return routesPermissionsMap;
}

export function getPermissionsForPath(
    pathname: string,
): Array<string> | undefined {
    const target = normalizePath(pathname);
    const allPermissions = new Map([
        ...getRoutesPermission(),
        ...Object.entries(SYSTEM_ADMIN_ROUTE_PERMISSIONS),
    ]);

    for (const [path, permissions] of allPermissions) {
        if (normalizePath(path) === target) {
            return permissions;
        }
    }

    return undefined;
}

export default Routes;
